export default __webpack_public_path__ + "static/media/empty-box.7d262288.gif";